// extracted by css-extract-rspack-plugin
export default {"badge":"NA9_5","hidden":"wLmjT"};